import { ROLE_LABELS } from '@kominiarz/shared';
import { ChevronRight, Plus, UserCog } from 'lucide-react';
import { Link } from 'react-router';
import { Alert } from '../../components/Alert';
import { Badge } from '../../components/Badge';
import { ButtonLink } from '../../components/Button';
import { ColorDot } from '../../components/ColorDot';
import { EmptyState } from '../../components/EmptyState';
import { Spinner } from '../../components/Loading';
import { PageBody } from '../../components/PageBody';
import { PageHeader } from '../../components/PageHeader';
import { errorMessage } from '../../lib/api';
import { useAdminUsers } from '../../lib/usersApi';
import { UserStatus } from './UserStatus';
import styles from './users.module.css';

export function UsersPage() {
  const users = useAdminUsers();
  return (
    <>
      <PageHeader
        title="Użytkownicy"
        actions={
          <ButtonLink to="/uzytkownicy/nowy" variant="primary" icon={<Plus aria-hidden="true" />}>
            Dodaj
          </ButtonLink>
        }
      />
      <PageBody>
        {users.isPending && <Spinner />}
        {users.isError && <Alert kind="error">{errorMessage(users.error)}</Alert>}
        {users.data && users.data.length === 0 && (
          <EmptyState icon={UserCog} title="Brak użytkowników" />
        )}
        {users.data && users.data.length > 0 && (
          <ul className={styles.list}>
            {users.data.map((u) => (
              <li key={u.id}>
                <Link to={`/uzytkownicy/${u.id}`} className={u.isActive ? styles.row : `${styles.row} ${styles.inactive}`}>
                  <ColorDot color={u.color} />
                  <span className={styles.main}>
                    <span className={styles.name}>{u.name}</span>
                    <span className={styles.meta}>Login: {u.login}</span>
                    <span className={styles.badges}>
                      <Badge tone={u.role === 'admin' ? 'strong' : 'neutral'}>{ROLE_LABELS[u.role]}</Badge>
                      <UserStatus user={u} />
                    </span>
                  </span>
                  <ChevronRight aria-hidden="true" className={styles.chevron} />
                </Link>
              </li>
            ))}
          </ul>
        )}
      </PageBody>
    </>
  );
}
